<template>
  <DatatableReportV3
    id="members-table"
    title="Members"
    download-url="/reports/members"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[6, "asc"]],
        columns: [
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "tags", title: "Tags", orderable: false },
          { data: "location_name", title: "Location Name" },
          { data: "address", filterName: "zipcode", orderable: false },
          {
            data: "membership_status",
            title: "Member Status",
            filterName: "membership_status"
          },
          { data: "program", filterName: "program" },
          {
            data: "membership_program_status",
            title: "Program Status",
            orderable: false,
            filterName: "membership_program_status"
          },
          { data: "systems", className: "text-center", searchable: false },
          { data: "since", filterName: "starts_on" },
          { data: "expires", filterName: "expires_on" },
          { data: "renews_at", title: "Next Billing Date" }
        ],
        vueComponents: [
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Members" });
  }
};
</script>

<style lang="scss" scoped></style>
